import { toString, Union, Record } from "../fable_modules/fable-library-js.4.19.0/Types.js";
import { currentNotificationContext, currentPageContext, NotificationContext, defaultNotificationContext, NotificationFilter_$reflection, NotificationContext_$reflection } from "../Context.fs.js";
import { GlobalMsg, GlobalMessageBox_Error_Z721C83C5, Msg as Msg_1, GlobalMsg_$reflection, Msg_$reflection as Msg_$reflection_1 } from "../../Bfs.Web.Portale/Types.fs.js";
import { class_type, list_type, union_type, record_type, bool_type, lambda_type, unit_type } from "../fable_modules/fable-library-js.4.19.0/Reflection.js";
import { ServerError_$reflection } from "../../Bfs.Web.Shared.FSharp/Errors.fs.js";
import { FSharpResult$2 } from "../fable_modules/fable-library-js.4.19.0/Result.js";
import { Benachrichtigungen_BenachrichtigungsTyp_$reflection, Benachrichtigungen_Benachrichtigung_$reflection } from "../../Bfs.Web.Data.Service.Contracts/Kundenportal.Contracts.fs.js";
import { Cmd_batch, Cmd_none } from "../fable_modules/Fable.Elmish.4.2.0/cmd.fs.js";
import { Http_downloadUrlById } from "../WebParts/User/Files/State.fs.js";
import { Page } from "../WebParts/User/Tickets/Types.fs.js";
import { Page as Page_1 } from "../WebParts/User/News/Types.fs.js";
import { ofArray, exists, empty, singleton } from "../fable_modules/fable-library-js.4.19.0/List.js";
import { eitherAsResult } from "../../Bfs.Web.Portale/Server.fs.js";
import { Benachrichtigungen } from "../Service.fs.js";
import { FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E } from "../fable_modules/Fable.React.9.4.0/./Fable.React.FunctionComponent.fs.js";
import { value as value_2 } from "../fable_modules/fable-library-js.4.19.0/Option.js";
import { int32ToString } from "../fable_modules/fable-library-js.4.19.0/Util.js";
import { React_useElmish_Z6C327F2E } from "../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/./Fable.React.UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../fable_modules/Fable.React.UseElmish.1.0.0-beta-001/../Fable.Elmish.4.2.0/program.fs.js";
import * as react from "react";

export class Model extends Record {
    constructor(ContextData, GlobalDispatch, OnceLoaded) {
        super();
        this.ContextData = ContextData;
        this.GlobalDispatch = GlobalDispatch;
        this.OnceLoaded = OnceLoaded;
    }
}

export function Model_$reflection() {
    return record_type("Bfs.Web.Kundenportal.Notifications.ContextProvider.Model", [], Model, () => [["ContextData", NotificationContext_$reflection()], ["GlobalDispatch", lambda_type(Msg_$reflection_1(), unit_type)], ["OnceLoaded", bool_type]]);
}

export class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Init", "CheckUnreadNotifications", "CheckUnreadNotificationsCompleted", "ToggleShowNotification", "LoadNotifications", "LoadNotificationsCompleted", "RefreshMobileListHeight", "ChangeFilter", "MarkAllAsRead", "MarkAllAsReadCompleted", "Navigate", "GlobalMsg"];
    }
}

export function Msg_$reflection() {
    return union_type("Bfs.Web.Kundenportal.Notifications.ContextProvider.Msg", [], Msg, () => [[["Item", lambda_type(Msg_$reflection(), unit_type)]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [bool_type, ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", bool_type]], [["ErrorValue", ServerError_$reflection()]]])]], [], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(Benachrichtigungen_Benachrichtigung_$reflection()), ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(Benachrichtigungen_Benachrichtigung_$reflection())]], [["ErrorValue", ServerError_$reflection()]]])]], [], [["Item", NotificationFilter_$reflection()]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [unit_type, ServerError_$reflection()], FSharpResult$2, () => [[["ResultValue", unit_type]], [["ErrorValue", ServerError_$reflection()]]])]], [["Item", Benachrichtigungen_BenachrichtigungsTyp_$reflection()]], [["Item", GlobalMsg_$reflection()]]]);
}

export class ContextProviderProps extends Record {
    constructor(GlobalDispatch, Children) {
        super();
        this.GlobalDispatch = GlobalDispatch;
        this.Children = Children;
    }
}

export function ContextProviderProps_$reflection() {
    return record_type("Bfs.Web.Kundenportal.Notifications.ContextProvider.ContextProviderProps", [], ContextProviderProps, () => [["GlobalDispatch", lambda_type(Msg_$reflection_1(), unit_type)], ["Children", list_type(class_type("Fable.React.ReactElement"))]]);
}

export function State_init(param) {
    return [new Model(defaultNotificationContext, param.GlobalDispatch, false), Cmd_none()];
}

function State_navigate(benachrichtigungsTyp, globalDispatch) {
    switch (benachrichtigungsTyp.tag) {
        case 1: {
            const url = Http_downloadUrlById(benachrichtigungsTyp.fields[0]);
            window.open(url, "_blank", "noopener,noreferrer");
            break;
        }
        case 2: {
            const info = benachrichtigungsTyp.fields[0];
            globalDispatch(new Msg_1(3, [info.ItsForMe ? (new Page(1, [info.TicketId])) : (new Page(2, [info.TicketId]))]));
            break;
        }
        default:
            globalDispatch(new Msg_1(3, [new Page_1(1, [benachrichtigungsTyp.fields[0]])]));
    }
}

export function State_update(msg, model) {
    let bind$0040_1, bind$0040_2, bind$0040_3, bind$0040_4, bind$0040_5, bind$0040;
    const handleError = (err) => {
        let copyOfStruct;
        const msg_1 = new Msg(11, [new GlobalMsg(3, [GlobalMessageBox_Error_Z721C83C5((copyOfStruct = err, toString(copyOfStruct)))])]);
        return singleton((dispatch) => {
            dispatch(msg_1);
        });
    };
    switch (msg.tag) {
        case 1:
            return [model, eitherAsResult(Benachrichtigungen.HasUnreadNotifications, undefined, (Item_4) => (new Msg(2, [Item_4])))];
        case 2:
            if (msg.fields[0].tag === 1) {
                return [model, handleError(msg.fields[0].fields[0])];
            }
            else {
                return [new Model((bind$0040_1 = model.ContextData, new NotificationContext(msg.fields[0].fields[0], bind$0040_1.NotificationsLoading, bind$0040_1.ShowNotifications, bind$0040_1.Notifications, bind$0040_1.Filter, bind$0040_1.ChangeFilter, bind$0040_1.ToggleShowNotifications, bind$0040_1.MarkAllRead, bind$0040_1.Navigate)), model.GlobalDispatch, true), Cmd_none()];
            }
        case 3: {
            window.getSelection().removeAllRanges();
            model.GlobalDispatch(new Msg_1(6, []));
            return [new Model((bind$0040_2 = model.ContextData, new NotificationContext(bind$0040_2.HasUnreadNotifications, bind$0040_2.NotificationsLoading, !model.ContextData.ShowNotifications, bind$0040_2.Notifications, bind$0040_2.Filter, bind$0040_2.ChangeFilter, bind$0040_2.ToggleShowNotifications, bind$0040_2.MarkAllRead, bind$0040_2.Navigate)), model.GlobalDispatch, model.OnceLoaded), model.ContextData.ShowNotifications ? Cmd_none() : singleton((dispatch_2) => {
                dispatch_2(new Msg(4, []));
            })];
        }
        case 4:
            return [new Model((bind$0040_3 = model.ContextData, new NotificationContext(bind$0040_3.HasUnreadNotifications, true, bind$0040_3.ShowNotifications, empty(), bind$0040_3.Filter, bind$0040_3.ChangeFilter, bind$0040_3.ToggleShowNotifications, bind$0040_3.MarkAllRead, bind$0040_3.Navigate)), model.GlobalDispatch, model.OnceLoaded), eitherAsResult(Benachrichtigungen.GetNotifications, undefined, (Item_5) => (new Msg(5, [Item_5])))];
        case 5:
            if (msg.fields[0].tag === 1) {
                return [model, handleError(msg.fields[0].fields[0])];
            }
            else {
                return [new Model((bind$0040_4 = model.ContextData, new NotificationContext(exists((_arg_2) => _arg_2.IstNeu, msg.fields[0].fields[0]), false, bind$0040_4.ShowNotifications, msg.fields[0].fields[0], bind$0040_4.Filter, bind$0040_4.ChangeFilter, bind$0040_4.ToggleShowNotifications, bind$0040_4.MarkAllRead, bind$0040_4.Navigate)), model.GlobalDispatch, model.OnceLoaded), singleton((dispatch_3) => {
                    dispatch_3(new Msg(6, []));
                })];
            }
        case 6: {
            model.GlobalDispatch(new Msg_1(6, []));
            model.GlobalDispatch(new Msg_1(6, []));
            return [model, Cmd_none()];
        }
        case 7:
            return [new Model((bind$0040_5 = model.ContextData, new NotificationContext(bind$0040_5.HasUnreadNotifications, bind$0040_5.NotificationsLoading, bind$0040_5.ShowNotifications, bind$0040_5.Notifications, msg.fields[0], bind$0040_5.ChangeFilter, bind$0040_5.ToggleShowNotifications, bind$0040_5.MarkAllRead, bind$0040_5.Navigate)), model.GlobalDispatch, model.OnceLoaded), singleton((dispatch_4) => {
                dispatch_4(new Msg(6, []));
            })];
        case 8:
            return [model, eitherAsResult(Benachrichtigungen.MarkAllAsRead, undefined, (Item_6) => (new Msg(9, [Item_6])))];
        case 9:
            if (msg.fields[0].tag === 1) {
                return [model, handleError(msg.fields[0].fields[0])];
            }
            else {
                return [model, Cmd_batch(ofArray([singleton((dispatch_5) => {
                    dispatch_5(new Msg(1, []));
                }), singleton((dispatch_6) => {
                    dispatch_6(new Msg(3, []));
                })]))];
            }
        case 10: {
            State_navigate(msg.fields[0], model.GlobalDispatch);
            return [model, singleton((dispatch_7) => {
                dispatch_7(new Msg(3, []));
            })];
        }
        case 11:
            return [model, Cmd_none()];
        default:
            return [new Model((bind$0040 = model.ContextData, new NotificationContext(bind$0040.HasUnreadNotifications, bind$0040.NotificationsLoading, bind$0040.ShowNotifications, bind$0040.Notifications, bind$0040.Filter, (newFilter) => {
                msg.fields[0](new Msg(7, [newFilter]));
            }, () => {
                msg.fields[0](new Msg(3, []));
            }, () => {
                msg.fields[0](new Msg(8, []));
            }, (benachrichtigungsTyp) => {
                msg.fields[0](new Msg(10, [benachrichtigungsTyp]));
            })), model.GlobalDispatch, false), Cmd_none()];
    }
}

function attachLocationChanged(f) {
    window.addEventListener("hashchange", f);
    return {
        Dispose() {
            window.removeEventListener("hashchange", f);
        },
    };
}

export const View = FunctionComponentPreparedRenderFunctionCache_GetOrAdd_3560CE5E((((value_2("C:\\BuildAgent\\work\\c238671ccc1e7da2\\BfsKundenportal\\src\\Bfs.Web.Kundenportal\\Notifications\\ContextProvider.fs") + "#L") + int32ToString(value_2(172))) + ";") + "Bfs.Web.Kundenportal.Notifications.ContextProvider.ContextProviderProps", value_2("View"), (props) => {
    let patternInput;
    const init = State_init(props);
    patternInput = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init, State_update, (_arg, _arg_1) => {
    }), undefined, undefined);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const currentPage = react.useContext(currentPageContext);
    const timeoutId = react.useState(0);
    react.useEffect(() => {
        clearTimeout(timeoutId[0]);
        const timeount = (model_1.OnceLoaded ? 4000 : 500) | 0;
        const page = toString(currentPage);
        if ((!model_1.OnceLoaded ? true : (page.indexOf("NewsItem") >= 0)) ? true : (page.indexOf("Ticket") >= 0)) {
            timeoutId[1](setTimeout(() => {
                dispatch(new Msg(1, []));
            }, timeount));
        }
    }, [currentPage, dispatch]);
    react.useEffect(() => {
        dispatch(new Msg(0, [dispatch]));
    }, [dispatch]);
    return react.createElement(currentNotificationContext.Provider, {
        value: model_1.ContextData,
    }, ...props.Children);
}, undefined, undefined, "Of");

//# sourceMappingURL=ContextProvider.fs.js.map
